exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grapejs {\n  position: fixed;\n  z-index: 99;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  left: 0;\n  top: 0;\n}\n\n/* Let's highlight canvas boundaries */\n.container-holder {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
